/**
 * Color data conversion utilities for API format
 */

import { ColorFormats, TinyColor } from "@ctrl/tinycolor";
import nearestColor from "nearest-color";
import colorNameList from "color-name-list/dist/colornames.bestof.json";
import { Color } from "@actions/items/useCreateColorAsset";

const allColors = colorNameList.reduce((o, { name, hex }) => Object.assign(o, { [name]: hex }), {});
// eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
const findNearestColorName = nearestColor.from(allColors);

/**
 * Convert a TinyColor instance to the color data format expected by the API.
 * Uses the nearest named color for the name field.
 *
 * @example
 * const color = new TinyColor("#FF0000");
 * const colorData = convertTinyColorToColorData(color);
 * // Returns: { name: "Red", hue: 0, saturation: 100, brightness: 100, ... }
 */
export const convertTinyColorToColorData = (potentialColor: TinyColor): Color => {
  const format: ColorFormats = potentialColor.format;
  const hsv = potentialColor.toHsv();
  const hexForName = potentialColor.toHexString();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const colorName: { name: string } = findNearestColorName(hexForName);

  return {
    name: colorName.name,
    hue: Number(hsv.h),
    saturation: Number(hsv.s) * 100,
    brightness: Number(hsv.v) * 100,
    alpha: Math.round(Number(hsv.a) * 100),
    cmyk: format === "cmyk" ? potentialColor.toCmykString() : "",
    pms: "",
    coverage: 100,
  };
};
